// src/Register.js
import axios from 'axios';
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { baseurl } from "../../utility/helper";
import { isAdaptiveTestReturn, ADAPTIVE_TEST_PROFILE_STATE } from "../../adaptiveTest/navigation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faUser,
  faEnvelope,
  faVenusMars,
  faCalendar,
  faHome,
  faCity,
  faMapMarkedAlt,
  faIdCard,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";

// Per-type config: label, placeholder, regex, hint
const ID_TYPE_CONFIG = {
  aadhaar: {
    label: "Aadhaar Card",
    placeholder: "Last 4 digits of Aadhaar",
    pattern: /^\d{4}$/,
    hint: "Must be exactly 4 digits (0–9).",
    numeric: true,
  },
  pan: {
    label: "PAN Card",
    placeholder: "Last 4 characters of PAN (e.g. 234F)",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
    numeric: false,
  },
  driving_license: {
    label: "Driving License",
    placeholder: "Last 4 characters of DL number",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
    numeric: false,
  },
  passport: {
    label: "Passport",
    placeholder: "Last 4 characters of Passport number",
    pattern: /^[A-Za-z0-9]{4}$/,
    hint: "Must be exactly 4 alphanumeric characters.",
    numeric: false,
  },
};

const Register = () => {
  const Candidateid = parseInt(sessionStorage.getItem("CandidateID")) || null;
  const [seatCount, setSeatCount] = useState(0);
  const [loading, setLoading] = useState(false);
  console.log(sessionStorage, seatCount);
  const location = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [fees, setFees] = useState(null);
  const [formData, setFormData] = useState({
    mobile: "",
    firstname: "",
    lastname: "",
    email: "",
    gender: "",
    dob: "",
    address: "",
    state: "",
    city: "",
    pincode: "",
    last_edu: "",
    education: "",
    privilege: 0,
    id_type: "aadhaar",   // which ID document the candidate is using
    aadhaar_last: "",     // last 4 of chosen ID (field name kept for backend compat)
  });
  const [formErrors, setFormErrors] = useState({});
  const Candidatedob = sessionStorage.getItem("Candidatedob") || null;
  // OTP step
  const [showVerificationForm, setShowVerificationForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);
  const fromPage = location.state?.page || "unknown";
  const testId = location.state?.testId || "";
  const tab = location.state?.tab || "";
  // Candidate details for sessionStorage after verification
  const [TestCanID, setTestcandiID] = useState(null);
  const [CanFirstName, setFirstname] = useState("");
  const [CanLastName, setLastName] = useState("");
  const [CanEmail, setEmail] = useState("");
  const [CanMobileNo, setMobileNo] = useState("");
  const [CanGender, setGender] = useState("");
  const [CanDob, setDob] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    // When ID type changes, clear the last-4 field so stale value doesn't carry over
    if (id === "id_type") {
      setFormData({ ...formData, id_type: value, aadhaar_last: "" });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const response = await axios.post(`${baseurl}/testcandidate`, {
        mobile: formData.mobile,
        firstname: formData.firstname,
        lastname: formData.lastname,
        email: formData.email,
        gender: formData.gender,
        dob: formData.dob,
        address: formData.address,
        state: formData.state,
        city: formData.city,
        pincode: formData.pincode,
        last_edu: formData.last_edu,
        education: formData.education,
        privilege: formData.privilege ? 1 : 0,
        id_type: formData.id_type,                          // new field
        aadhaar_last: formData.aadhaar_last.toUpperCase(), // normalise case for backend
      });

      try {
        const response = await fetch(`${baseurl}/send-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ candidate: formData.email }),
        });

        const data = await response.json();
        if (data.success) {
          console.log(data);
          Swal.fire({
            toast: true,
            position: "top-end",
            icon: "success",
            title: "Form Submitted! OTP Sent to your email.",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          setTestcandiID(data.test_candidate_id);
          setFirstname(data.first_name);
          setLastName(data.last_name);
          setEmail(data.email);
          setMobileNo(data.mobile_no);
          setGender(data.gender);
          setDob(data.dob);
          setUserId(data.userId);
          setShowVerificationForm(true);
          setLoading(false);
        } else {
          alert(data.message);
          setTimeout(() => {
            navigate("/Register");
          }, 500);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error:", error);
        setLoading(false);
      }

      setFormData({
        mobile: "",
        firstname: "",
        lastname: "",
        email: "",
        gender: "",
        dob: "",
        address: "",
        state: "",
        city: "",
        pincode: "",
        last_edu: "",
        education: "",
        privilege: 0,
        id_type: "aadhaar",
        aadhaar_last: "",
      });
      setFormErrors({});
    } catch (error) {
      console.error("Error registering Test:", error);
      setLoading(false);
      if (error.response && error.response.status === 409) {
        const msg = error.response.data?.message || "";
        Swal.fire({
          title: "Already Registered!",
          text: msg.includes("Aadhaar")
            ? "This ID number is already registered."
            : "You are already registered as a candidate. Please login.",
          icon: "info",
          confirmButtonText: msg.includes("Aadhaar") ? "OK" : "Candidate Login",
        }).then((result) => {
          if (result.isConfirmed && !msg.includes("Aadhaar")) {
            navigate("/Candidatelogin");
          }
        });
      } else if (error.response && error.response.status === 403) {
        Swal.fire({
          title: "Membership Alert!",
          text: "You are already a member, You Cannot Register.",
          icon: "info",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error!",
          text: "There was an error registering the test. Please try again.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    }
  };

  // Verify OTP
  const handleVerifyOtp = async () => {
    try {
      const response = await fetch(`${baseurl}/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, otp }),
      });

      const data = await response.json();
      if (data.success) {
        sessionStorage.setItem("CandidateID", TestCanID);
        sessionStorage.setItem("CandidateFname", CanFirstName);
        sessionStorage.setItem("CandidateLname", CanLastName);
        sessionStorage.setItem("CandidateEmail", CanEmail);
        sessionStorage.setItem("CandidateMobile", CanMobileNo);
        sessionStorage.setItem("Candidategender", CanGender);
        sessionStorage.setItem("Candidatedob", CanDob);

        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "OTP Verified!",
          showConfirmButton: false,
          timer: 2000,
          timerProgressBar: true,
        }).then(() => {
          if (isAdaptiveTestReturn(fromPage)) {
            navigate("/Profile", { state: ADAPTIVE_TEST_PROFILE_STATE });
          } else if (fromPage == "PreTest") {
            navigate(`/${fromPage}`);
          } else if (fromPage == "JoinUs") {
            navigate(`/${fromPage}`, { state: { tab: "#three" } });
          } else {
            navigate(`/${fromPage}`, { state: { testId: testId } });
          }
          window.location.reload();
        });
      } else {
        Swal.fire("Invalid OTP", data.message, "error");
      }
    } catch (error) {
      console.error("OTP Verify Error:", error);
      Swal.fire("Error", "Failed to verify OTP", "error");
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
    try {
      const response = await fetch(`${baseurl}/send-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ candidate: formData.email }),
      });
      const data = await response.json();
      if (data.success) {
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "OTP Resent Successfully!",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      } else {
        Swal.fire("Error", data.message, "error");
        setTimeout(() => navigate("/Register"), 500);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const validateForm = () => {
    const errors = {};
    const {
      mobile, firstname, lastname, email, gender, dob,
      address, state, city, last_edu, pincode,
      id_type, aadhaar_last,
    } = formData;

    // ── ID validation ──────────────────────────────────────────────────────────
    const cfg = ID_TYPE_CONFIG[id_type] || ID_TYPE_CONFIG.aadhaar;
    const trimmed = aadhaar_last.trim();

    if (!trimmed) {
      errors.aadhaar_last = `Last 4 characters of your ${cfg.label} are required.`;
    } else if (!cfg.pattern.test(trimmed)) {
      errors.aadhaar_last = cfg.hint;
    } else if (/^(.)\1{3}$/i.test(trimmed)) {
      // Blocks 0000, 1111, AAAA, etc. — all-same-character sequences are invalid
      errors.aadhaar_last = `"${trimmed.toUpperCase()}" is not a valid ID number. Please enter the actual last 4 characters of your ${cfg.label}.`;
    }
    // ──────────────────────────────────────────────────────────────────────────

    if (!mobile.match(/^\d{10}$/)) {
      errors.mobile = "Mobile number must be 10 digits.";
    }
    if (!firstname?.trim()) {
      errors.firstname = "First name is required.";
    }
    if (!lastname?.trim()) {
      errors.lastname = "Last name is required.";
    }
    if (!email) {
      errors.email = "Email is required.";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errors.email = "Email is invalid.";
    }
    if (!gender) {
      errors.gender = "Gender is required.";
    }
    if (!dob) {
      errors.dob = "Date of Birth is required.";
    } else {
      const today = new Date();
      const birthDate = new Date(dob);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }
      if (age < 1) {
        errors.dob = "Your age is below 1 year. You are not eligible for registration.";
      }
    }
    if (!address?.trim()) errors.address  = "Address is required.";
    if (!state?.trim())   errors.state    = "State is required.";
    if (!city?.trim())    errors.city     = "City is required.";
    if (!last_edu?.trim()) errors.last_edu = "Last Completed Education is required.";


    return errors;
  };

  if (error) {
    return <div>{error}</div>;
  }

  const inputClass = (field) =>
    `form-control ${formErrors[field] ? "is-invalid" : ""}`;

  const selectedIdCfg = ID_TYPE_CONFIG[formData.id_type] || ID_TYPE_CONFIG.aadhaar;

  return (
    <div>
      <div className="event" style={{ marginTop: "100px" }}>

        {loading && (
          <div className="text-center my-3">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p>Form Submitted Successfully..</p>
            <p>Please Wait Sending OTP...</p>
          </div>
        )}
        <div className="container" style={{ paddingTop: "30px" }}>
          <button className="btn btn-secondary mt-3" onClick={() => navigate("/Candidatelogin")}>
            <i className="bi bi-arrow-left" style={{ color: 'white' }}></i> Back
          </button>
          <div className="row justify-content-center">
            <div
              className="col-lg-6 shadow p-4 rounded"
              style={{ border: "1px solid #cbcaca", backgroundColor: "#fff" }}
            >
              <center>
                <h2 className="fw-bold mb-4" style={{ fontSize: "22px" }}>
                  Provide the following information to register.
                </h2>
              </center>
              <br />

              {!showVerificationForm ? (
                <form onSubmit={handleSubmit}>

                  {/* Email */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="email" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faEnvelope} className="icon me-2" />
                      Email
                    </label>
                    <div className="col-sm-8">
                      <input type="email" className={inputClass("email")} id="email"
                        placeholder="Enter Email" value={formData.email} onChange={handleChange} required />
                      {formErrors.email && <small className="text-danger">{formErrors.email}</small>}
                    </div>
                  </div>

                  {/* First Name */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="firstname" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faUser} className="me-2 icon" />
                      First Name
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("firstname")} id="firstname"
                        value={formData.firstname} onChange={handleChange} placeholder="Enter First name" required />
                      {formErrors.firstname && <small className="text-danger">{formErrors.firstname}</small>}
                    </div>
                  </div>

                  {/* Last Name */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="lastname" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faUser} className="me-2 icon" />
                      Last Name
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("lastname")} id="lastname"
                        value={formData.lastname} placeholder="Enter Last Name" onChange={handleChange} required />
                      {formErrors.lastname && <small className="text-danger">{formErrors.lastname}</small>}
                    </div>
                  </div>

                  {/* Mobile */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="mobile" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faPhone} className="me-2 icon" />
                      Mobile Number
                    </label>
                    <div className="col-sm-8">
                      <input type="tel" className={inputClass("mobile")} id="mobile"
                        value={formData.mobile} onChange={handleChange} maxLength="10"
                        placeholder="Enter 10-digit mobile" required />
                      {formErrors.mobile && <small className="text-danger">{formErrors.mobile}</small>}
                    </div>
                  </div>

                  {/* Gender */}
                  <div className="form-group row align-items-center mb-3">
                    <label className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faVenusMars} className="me-2 icon" />
                      Gender
                    </label>
                    <div className="col-sm-8">
                      <select name="gender" id="gender" value={formData.gender}
                        onChange={handleChange} className="form-select" required>
                        <option value="">Select Gender</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    {formErrors.gender && <small className="text-danger">{formErrors.gender}</small>}
                  </div>

                  {/* DOB */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="dob" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faCalendar} className="me-2 icon" />
                      Date of Birth
                    </label>
                    <div className="col-sm-8">
                      <input type="date" className={inputClass("dob")} id="dob"
                        value={formData.dob} onChange={handleChange} required />
                      {formErrors.dob && <small className="text-danger">{formErrors.dob}</small>}
                    </div>
                  </div>

                  {/* Address */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="address" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faHome} className="me-2 icon" />
                      Address
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("address")} id="address"
                        placeholder="Enter Address" value={formData.address} onChange={handleChange} required />
                      {formErrors.address && <small className="text-danger">{formErrors.address}</small>}
                    </div>
                  </div>

                  {/* State */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="state" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faMapMarkedAlt} className="me-2 icon" />
                      State
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("state")} id="state"
                        placeholder="Enter State" value={formData.state} onChange={handleChange} required />
                      {formErrors.state && <small className="text-danger">{formErrors.state}</small>}
                    </div>
                  </div>

                  {/* City */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="city" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faCity} className="me-2 icon" />
                      City
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("city")} id="city"
                        placeholder="Enter City" value={formData.city} onChange={handleChange} required />
                      {formErrors.city && <small className="text-danger">{formErrors.city}</small>}
                    </div>
                  </div>

                  {/* Pincode */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="pincode" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faMapMarkedAlt} className="me-2 icon" />
                      Pincode
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("pincode")} id="pincode"
                        maxLength="6" placeholder="Enter Pincode" value={formData.pincode}
                        onChange={handleChange} required />
                      {formErrors.pincode && <small className="text-danger">{formErrors.pincode}</small>}
                    </div>
                  </div>

                  {/* ── ID Document — type selector + last-4 input ── */}
                  <div className="form-group row align-items-center mb-1">
                    <label htmlFor="id_type" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faIdCard} className="me-2 icon" />
                      ID Document
                    </label>
                    <div className="col-sm-8">
                      <select id="id_type" className="form-select"
                        value={formData.id_type} onChange={handleChange} required>
                        <option value="aadhaar">Aadhaar Card</option>
                        <option value="pan">PAN Card</option>
                        <option value="driving_license">Driving License</option>
                        <option value="passport">Passport</option>
                      </select>
                      <small className="text-muted">
                        Select another only if you don't have Aadhaar.
                      </small>
                    </div>
                  </div>

                  <div className="form-group row align-items-center mb-3 mt-2">
                    <label htmlFor="aadhaar_last" className="col-sm-4 col-form-label">
                      Document Number of {selectedIdCfg.label}
                    </label>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className={inputClass("aadhaar_last")}
                        id="aadhaar_last"
                        maxLength="4"
                        placeholder={selectedIdCfg.placeholder}
                        value={formData.aadhaar_last}
                        onChange={handleChange}
                        required
                      />
                      <small className="text-muted">{selectedIdCfg.hint}</small>
                      {formErrors.aadhaar_last && (
                        <small className="text-danger d-block">{formErrors.aadhaar_last}</small>
                      )}
                    </div>
                  </div>
                  {/* ─────────────────────────────────────────────── */}

                  {/* Education (text) */}
                  <div className="form-group row align-items-center mb-3">
                    <label htmlFor="last_edu" className="col-sm-4 col-form-label">
                      <FontAwesomeIcon icon={faGraduationCap} className="me-2 icon" />
                      Education
                    </label>
                    <div className="col-sm-8">
                      <input type="text" className={inputClass("last_edu")} id="last_edu"
                        placeholder="Enter Last Completed Education"
                        value={formData.last_edu} onChange={handleChange} required />
                      {formErrors.last_edu && <small className="text-danger">{formErrors.last_edu}</small>}
                    </div>
                  </div>

                   {/* Education */}
                <div className="form-group row align-items-center mb-4">
                  <label htmlFor="education" className="col-sm-4 col-form-label">
                    <FontAwesomeIcon icon={faGraduationCap} className="me-2 icon" />
                    Education Level
                  </label>
                  <div className="col-sm-8">
                    <select
                      className={inputClass("education")}
                      id="education"
                      value={formData.education}
                      onChange={handleChange}
                      required
                    >
                      <option value="" disabled>
                        Select Education Level
                      </option>
                      <option value="Low">Low (School)</option>
                      <option value="Medium">Medium (Graduate)</option>
                      <option value="High">High (And above)</option>
                    </select>
                    {formErrors.education && (
                      <small className="text-danger">{formErrors.education}</small>
                    )}
                  </div>
                </div>


                  {/* Under Privilege */}
                  {/* <div className="col-md-12 mt-2 mb-4" style={{ paddingTop: '0px', justifyItems: 'center' }}>
                    <div className="form2-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="privilege"
                        name="privilege"
                        checked={formData.privilege || false}
                        onChange={(e) =>
                          setFormData({ ...formData, privilege: e.target.checked })
                        }
                      />
                      <label className="form-check-label" htmlFor="privilege">
                        Under Privilege
                      </label>
                    </div>
                  </div> */}

                  {/* Submit */}
                  {Object.keys(formErrors).length > 0 && (
                    <div className="alert alert-danger mb-3">
                      <strong>Please correct the following fields:</strong>
                      <ul className="mb-0 mt-2">
                        {Object.entries(formErrors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                  <center>
                    <button type="submit" className="btn btn-primary px-4"
                      style={{ backgroundColor: "#000C80" }}>
                      Submit
                    </button>
                  </center>
                </form>
              ) : (
                <form
                  onSubmit={(e) => { e.preventDefault(); handleVerifyOtp(); }}
                  className="shadow p-4 rounded bg-white"
                >
                  <h3 className="mb-4">Enter OTP</h3>
                  <p>We sent an OTP to <b>{CanEmail}</b>. Please enter it below:</p>

                  <div className="mb-3 position-relative">
                    <input
                      type="text"
                      className="form-control text-center"
                      style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        letterSpacing: '4px',
                        height: '55px',
                        border: '2px solid transparent',
                        borderRadius: '10px',
                        background: 'linear-gradient(white, white) padding-box, linear-gradient(45deg, #007bff, #28a745) border-box',
                        boxShadow: '0 4px 15px rgba(0,123,255,0.1)'
                      }}
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      maxLength="6"
                      placeholder="Enter OTP"
                      required
                    />
                  </div>

                  <center>
                    <button type="submit" className="btn btn-success">Verify OTP</button>
                  </center>
                </form>
              )}
            </div>
          </div>
          <br />
        </div>
      </div>
    </div>
  );
};

export default Register;